<script setup>
import PageTitleSection from '@/components/PageTitleSection.vue';
import { useFixturesStore } from '@/stores/fixtures';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { safeTranslate } from '@/helpers';
import { useI18n } from 'vue-i18n';

const { t, te } = useI18n()
const fixtures = useFixturesStore()
const { getSport , getCompetitionsByRegion} = storeToRefs(fixtures)
const route = useRoute()
const si = computed(() => route.params.id)

const regionTranslation = (region) => { 
    return safeTranslate('regions', region.ri, t, te , region.rn)
}
</script>
<template>
    <div class="flex w-full">
        <div class="flex-1">
            <PageTitleSection
                :title="$te(`sports.${si}`) ? $t(`sports.${si}`) : getSport(si)?.sn"
            />
            <div>
                <ul class="list-none divide-y divide-neutral-600/50">
                    <li
                        v-for="region in getCompetitionsByRegion(si)"
                        :key="region.ri"
                    >
                        <RouterLink
                            :to="`/ps/${si}/r/${region.ri}`"
                            class="py-4 px-4 w-full flex items-center justify-between hover:bg-neutral-600/30 cursor-pointer"
                        >
                            <div class="flex items-center space-x-3">
                            <img :src="`/loc/${region.ri}.svg`" class="w-5 h-5 rounded-full" alt="">
                            <h3 class="text-[15px] text-white font-bold">{{ regionTranslation(region) }}</h3>
                            </div>

                            <img src="/chevron-right.svg" class="w-5 h-5"/>
                        </RouterLink>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
